import { useTranslation } from "react-i18next";
import { Stack, useTheme } from "@mui/material";
import { FoodsCheckbox, FoodsTooltip } from "@foodpilot/foods";
import GenericValueIcon from "src/assets/icons/hint.svg?react";

type GenericValueCheckboxProps = {
    onChange: (checked: boolean) => void;
    isSelected: boolean;
    disabled: boolean;
};

export const GenericValueCheckbox = (props: GenericValueCheckboxProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const { onChange, isSelected, disabled } = props;

    return (
        <Stack direction="column">
            <Stack direction="row" alignItems="center">
                <FoodsCheckbox
                    selectedItems={isSelected ? [true] : []}
                    values={[true]}
                    onChange={(v) => {
                        const isChecked = v.length > 0 && v[0] === true;
                        onChange(isChecked);
                        return;
                    }}
                    getName={() => t("property.use_generic_value")}
                    CheckboxProps={{ disabled }}
                    FormControlLabelProps={{
                        disabled,
                        sx: {
                            gap: "3px",
                            ".MuiTypography-root": {
                                ...theme.typography.body,
                            },
                        },
                    }}
                />
                <FoodsTooltip title={t("property.generic_value_info")} placement="top">
                    <GenericValueIcon width={theme.spacing(2)} />
                </FoodsTooltip>
            </Stack>
        </Stack>
    );
};
